// extracted by mini-css-extract-plugin
module.exports = {"productTileWrapper":"ProductTileWrapper_productTileWrapper__ZwWI8","maxFour":"ProductTileWrapper_maxFour__rgbHs","maxEight":"ProductTileWrapper_maxEight__yEf7U"};